import React from 'react';

const ExchangeRateTitle = ({ record }) => {
	return <span>ExchangeRate {record ? `"${record.currencyCode}"` : ''}</span>;
};

export default ExchangeRateTitle;
